import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102042.jpg'
import img2 from '../assets/others/11102043.jpg'
import checkicon from '../assets/icons/check-circle-wt.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from 'react-helmet-async'
library.add(fas)


const Vision = () => {
  return (
    <div>
        <Helmet>
        <title>Our Vision & Mission in VLSI Training Industry | Takshila VLSI</title>
        <meta name="description" content="Explore Takshila VLSI’s vision and mission focused on innovation and excellence in training. Start your journey toward a successful tech career. Join us now!" />
        <link rel="canonical" href="https://www.takshila-vlsi.com/vision/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Our Vision & Mission in VLSI Training Industry | Takshila VLSI" />
        <meta property="og:description" content="Explore Takshila VLSI’s vision and mission focused on innovation and excellence in training. Start your journey toward a successful tech career. Join us now!" />
        <meta property="og:url" content="https://www.takshila-vlsi.com/vision/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2019-06-02T21:55:29+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <Header/>
        <main>
        <section className='section-banner pg-banner bg-6 pt-4'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-lg-5">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title pb-3'>Our Vision</h1>
                                    <p className='pg-title-desc'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg-8 img-radius">
                            <img src={img} alt=''/>
                          </div>
                          </div>
            </div>
            </section>
            <section className='p-lg-5 bg-6 pt-4 pb-4 vision-sec'>
            <div class="container ">
                <div class="row">
                
                    <div class="col-lg-12">
                    <div className='bg-drk-3 dark-bg p-5 radius-1'>
                    <div class="col-lg-12">
                        <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">Prepare and build students in learning new techniques while adapting to changes quickly.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">Provide a solid stream of productive and employable engineers while creating a talent pool for the Electronics and Semiconductor industry.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">Provide an all-inclusive methodology to skill development. Our lab sessions, in-class sessions, and live projects are crafted in such a way for you to gain industry experience.</div>
                            </div>
                            
                    </div>  
                    </div>  
                    </div> 
                </div>
                </div>
            </section>
            
            <section className='bg-drk-3 dark-bg p-5'>
                <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-lg-4 mb-4">
                                <div class="pg-title-sec">
                                    <h2 class="ws-section_heading mb-3 text-left">Our core values</h2>
                                   
                                </div>
                              </div>
                              <div className='col-lg'>
                                    <div className='row'>
                                        <div class="col-lg-6 mb-lg-5 mb-3">
                                        <div className='icon radius-1 mb-3'>
                                                <div className='icon mb-3'>
                                                <FontAwesomeIcon icon="fa-solid fa-lightbulb" />
                                                </div>
                                        <div className='icon-content'>
                                            <div className='icon-card-head mb-2'>Pioneering Innovation</div>
                                        </div>
                                         </div>
                                        </div>
                                        <div class="col-lg-6 mb-lg-5 mb-3">
                                        <div className='icon radius-1 mb-3'>
                                                <div className='icon mb-3'>
                                                <FontAwesomeIcon icon="fa-solid fa-award" />
                                                </div>
                                        <div className='icon-content'>
                                            <div className='icon-card-head mb-2'>Academic Excellence</div>
                                        </div>
                                         </div>
                                        </div>
                                        <div class="col-lg-6 mb-lg-5 mb-3">
                                        <div className='icon radius-1 mb-3'>
                                                <div className='icon mb-3'>
                                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                                                </div>
                                        <div className='icon-content'>
                                            <div className='icon-card-head mb-2'>Research-Driven Success</div>
                                        </div>
                                         </div>
                                        </div>
                                        <div class="col-lg-6 mb-lg-5 mb-3">
                                        <div className='icon radius-1 mb-3'>
                                                <div className='icon mb-3'>
                                                <FontAwesomeIcon icon="fa-solid fa-arrow-up-right-dots" />
                                                </div>
                                        <div className='icon-content'>
                                            <div className='icon-card-head mb-2'>Collaboration and Growth</div>
                                        </div>
                                         </div>
                                        </div>
                                    </div>
                              </div>
                          </div>
                         
                </div>
            </section>
            <section className='p-lg-5 pt-4 pb-4'>
                <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-lg">
                                <div class="pg-title-sec">
                                    <h2 class="ws-section_heading mb-3">Mission Statement</h2>
                                    <p className='ws-section_sub-heading h3'>Offering excellence in training of VLSI Technologies. </p>
                                </div>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg-8 img-radius">
                            <img src={img2} alt=''/>
                          </div>
                          </div>
                </div>
            </section>
            </main>
        <Enrollaction/>
        <Partnersec/> 
        <Footer/>
    </div>
  )
}

export default Vision